import { render, staticRenderFns } from "./OfferTypeButton.vue?vue&type=template&id=0644d079&scoped=true&"
import script from "./OfferTypeButton.vue?vue&type=script&lang=js&"
export * from "./OfferTypeButton.vue?vue&type=script&lang=js&"
import style0 from "./OfferTypeButton.vue?vue&type=style&index=0&id=0644d079&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0644d079",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCol } from 'vuetify/lib/components/VGrid';
installComponents(component, {VCol})
